import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, createContext, useContext } from 'react';

const defaultValues = {
    ids: {
        titleId: '',
        descriptionId: ''
    },
    registerTitle: ()=>null,
    registerDescription: ()=>null
};
const FormSectionContext = /*#__PURE__*/ createContext(defaultValues);
const useFormSectionIds = ()=>useContext(FormSectionContext);
const FormSectionProvider = ({ children })=>{
    const [ids, setIds] = useState(defaultValues.ids);
    const registerTitle = useCallback((id)=>{
        setIds((prev)=>({
                ...prev,
                titleId: id
            }));
    }, []);
    const registerDescription = useCallback((id)=>{
        setIds((prev)=>({
                ...prev,
                descriptionId: id
            }));
    }, []);
    return jsx(FormSectionContext.Provider, {
        value: {
            ids,
            registerTitle,
            registerDescription
        },
        children: children
    });
};
FormSectionProvider.displayName = 'FormSection.Provider';

export { FormSectionContext, FormSectionProvider, useFormSectionIds };
//# sourceMappingURL=FormSection.Context.es.js.map
